<template>
  <v-dialog persistent no-click-animation
            content-class="graph-details"
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">

      <v-btn v-bind="attrs"
             v-on="on" block large color="primary" outlined>
        <slot name="activator"></slot>
      </v-btn>
    </template>
    <v-card tile flat class="graph-card">
      <div class="graph-fullscreen">
        <slot name="content">
        </slot>

      </div>
      <v-card-actions>
        <v-btn @click="dialog = false" depressed color="primary">
          Cancel
        </v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>
  export default {
    name: "DetailsFullscreen",
    props: ['title'],
    data: () => ({
      dialog: false,
      show_graph: false,
    }),
    methods: {}
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .graph-card {

    .graph-fullscreen {
      padding: 0 1rem;
      @media #{map-get($display-breakpoints, 'lg-and-up')} {
        padding: 0 5rem;
      }
      height: 100%;

      .graph-body {
        height: 100%;

        & > div {
          height: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/Elements/DetailsFullscreen.vue